<template>
  <div class="loading-state" v-if="!state.isLoadedOrNotInit()">
    <div v-if="state.isLoading()" class="loading-msg">
      {{text}}
      <v-progress-linear
        :active="true"
        :indeterminate="true"
        absolute
        bottom
        color="deep-purple accent-4"
      ></v-progress-linear>
    </div>
    <div class="error-msg" v-else-if="state.isError()">
      <div v-if="state.msg && state.msg.response && state.msg.response.data.status">
        <div v-if="state.msg.response.data.status == 403">
          Access Forbidden on Resource
          <div v-if="state.msg.response.data.error && state.msg.response.data.error.msg">
            {{state.msg.response.data.error.msg}}
          </div>
        </div>
        <div v-else-if="state.msg.response.data.status == 404">Resource not found</div>
        <div v-else-if="state.msg.response.data.error.status">
          {{state.msg.response.data.error.status}}: {{state.msg.response.data.error.code}} - 
          {{state.msg.response.data.error.message}}
        </div>
        <div v-else>
          Error on resource
          {{state.msg.response}}
        </div>
      </div>
      <div v-else>
        no records found!
        <div v-if="state.msg">{{state.msg}}</div>
      </div>
    </div>
    <div v-else>State: {{state}}</div>
  </div>
</template>
<script>
export default {
  props: {
    state: Object,
    text: {
      default: 'loading..',
      type: String
    }
  }
}
</script>
<style lang="scss" scoped>
  .error-msg {
    font-size: 12px;
    text-transform: uppercase;
    color: #9b9b9b;
    font-weight: normal;
    background-color: #fff;
    margin: 5px 0;
    text-align: center;
    border: 1px solid #e9e9e9;
    padding: 25px 0 25px;
  }
  .loading-msg {
    text-align: center;
    img {
      margin-right: 10px;
    }
  }
</style>
